import { OBJLoader } from 'three-obj-mtl-loader'

// Import 3d models
import engine from '../../resources/3d/engine.obj'
import usability from '../../resources/3d/usability.obj'
import identity from '../../resources/3d/identity.obj'
import brain from '../../resources/3d/machine-trainers.obj'

var THREE = require('three');


export default scene => {
    // OBJ Loader
    const objLoader = new OBJLoader();

    let onProgress = function ( xhr ) {
        if ( xhr.lengthComputable ) {
            var percentComplete = xhr.loaded / xhr.total * 100;
            console.log( Math.round( percentComplete, 2 ) + '% downloaded' );
        }
    };
    let onError = function () { console.log('error') };

    objLoader.load( engine, function ( object ) {
        object.scale.set( .005, .005, .005 );
        object.position.x = 120;
        object.position.y = 0;
        object.position.z = 2;
        object.castShadow = true;
        object.receiveShadow = true;
        object.rotation.y = -1.22173;
        scene.add( object );
        }, onProgress, onError );
    objLoader.load( usability, function ( object ) {
        object.scale.set( .005, .005, .005 );
        object.position.x = 10;
        object.position.y = -2.5;
        object.position.z = -120;
        object.rotation.y = 4.10152;
        object.castShadow = true;
        object.receiveShadow = true;
        scene.add( object );
        }, onProgress, onError );
    objLoader.load( identity, function ( object ) {
        object.scale.set( .006, .006, .006 );
        object.rotation.y = 0.523599;
        object.position.x = -120;
        object.position.y = -11;
        object.position.z = -3;
        object.castShadow = true;
        object.receiveShadow = true;
        scene.add( object );
    }, onProgress, onError );
    objLoader.load( brain, function ( object ) {
        object.scale.set( .005, .005, .005 );
        object.castShadow = true;
        object.receiveShadow = true;
        object.position.x = -3;
        object.position.y = -9;
        object.position.z = 120;
        object.rotation.y = -2.0944;
        object.castShadow = true;
        object.receiveShadow = true;
        scene.add( object );
    }, onProgress, onError );

    function update(time) {

    }

    return {
        update
    }
}
